/**
 * Constants for book types and genres
 */

export const BOOK_TYPES = [
    { value: 'PROSE', label: 'Próza' },
    { value: 'POETRY', label: 'Poezie' },
    { value: 'DRAMA', label: 'Drama' }
];

export const CHARACTER_ROLES = [
    { value: 'PROTAGONIST', label: 'Protagonista' },
    { value: 'ANTAGONIST', label: 'Antagonista' },
    { value: 'SUPPORTING', label: 'Vedlejší postava' }
];
